import { Controller } from "@hotwired/stimulus";
import { previewSetup } from "./customization/lib";
import { liquid } from "./customization/category";
import CustomizationRequest from "./customization/request";

// Connects to data-controller="site-builder--update-stream"
export default class extends Controller {
  connect() {
    const url = this.element.dataset.pagePath;
    if (url) {
      const currentUrl = liquid.values.url;
      if (currentUrl !== url) {
        CustomizationRequest.notifyPageChanged();
      }
      liquid.update({ url });
    }

    const event = new Event("site-builder:customization-loaded");
    document.dispatchEvent(event);

    /*
        Since this is not a full page reload,
        ensure that scripts which rely on a full reload
        are executed after the customization is rendered.
     */
    const loadEvent = new Event('load');
    window.dispatchEvent(loadEvent);
    previewSetup();
  }
}
